import type { Change } from '@gitbook/slate';

/**
 * Toggle the checked state of a list item
 */
export function checkTaskItem(change: Change, key: string, checked: boolean): Change {
    return change.setNodeByKey(key, { data: { checked } });
}
